import Vue from 'vue'
import axios from 'axios'
import { uuid, noop } from '@/utils/index'
import {
  baseURL,
  contentType,
  debounce,
  invalidCode,
  noPermissionCode,
  requestTimeout,
  successCode,
} from '@/config'
import { DEFAULT_LANGUAGE } from '@transsion/hotent-ui/packages/Language'
import store from '@/store'
import qs from 'qs'
import { isArray } from '@/utils/validate'
import { Message } from 'element-ui'

let loadingInstance

/**
 * 处理code异常
 * @param {*} code
 * @param {*} msg
 */
const handleCode = (code, msg, errorMessageClosed = noop) => {
  switch (code) {
    case invalidCode:
      store.dispatch('user/logout').then(() => {
        store.dispatch('user/toLoginUrl')
      })
      break
    case noPermissionCode:
      Vue.prototype.$baseMessage(
        msg || '无访问权限',
        'error',
        errorMessageClosed
      )
      break
    default:
      Vue.prototype.$baseMessage(
        msg || `后端接口${code}异常`,
        'error',
        errorMessageClosed
      )
      break
  }
}

const instance = axios.create({
  baseURL,
  timeout: requestTimeout,
  headers: {
    'Content-Type': contentType,
  },
})

instance.interceptors.request.use(
  (config) => {
    if (!config.headers) {
      config.headers = {}
    }

    if (config.headers.constructor == String) {
      try {
        config.headers = JSON.parse(config.headers)
      } catch (e) {
        Message.error(`请求头部不是有效的JSON格式:${config.headers}`)
        throw e
      }
    }

    // 如果 接口上没有设置 p-auth 和 p-rtoken，就从 store 中获取
    if (
      !config.noDefaultHeaders &&
      //如果是请求auth接口，则不带token
      config.url.indexOf('/auth?') < 0
    ) {
      const tokens = store.getters['user/tokens']
      config.headers['P-Auth'] = tokens.token
      config.headers['P-RToken'] = tokens.rtoken
    }

    // 添加requestId
    config.headers['P-RequestId'] =
      localStorage.getItem('requestId') || 'front-' + uuid()

    if (
      config.data &&
      config.headers['Content-Type'] ===
        'application/x-www-form-urlencoded;charset=UTF-8'
    )
      config.data = qs.stringify(config.data)
    config.headers['P-LangId'] = config.headers['Accept-Language'] =
      localStorage.getItem('lang') || DEFAULT_LANGUAGE
    if (debounce.some((item) => config.url && config.url.includes(item)))
      loadingInstance = Vue.prototype.$baseLoading()
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

instance.interceptors.response.use(
  (response) => {
    if (loadingInstance) loadingInstance.close()
    const { data, config, headers } = response
    const { code, message } = data

    if (config) {
      const { responseType } = config
      // 请求的返回值类型为arraybuffer时返回headers
      if (responseType && responseType == 'arraybuffer') {
        // let blob = new Blob([response.data])
        // const fileName = decodeURIComponent(
        //   response.headers['content-disposition'].split(';')[1].split('filename=')[1]
        // )
        // saveAs(blob, fileName)
        return { data, headers }
      }
    }

    if (headers) {
      // 附件下载，需要返回 headers
      const content = headers['content-disposition']
      if (content && content.startsWith('attachment;')) {
        return { data, headers }
      }
    }

    // TODO：暂时允许请求不返回code
    if (code === undefined) {
      return data
    }

    // 操作正常Code数组
    const codeVerificationArray = isArray(successCode)
      ? [...successCode]
      : [...[successCode]]
    // 是否操作正常
    if (codeVerificationArray.includes(code)) {
      return data
    } else {
      handleCode(code, message)
      return Promise.reject(
        '请求异常拦截:' + JSON.stringify({ url: config.url, code, message }) ||
          'Error'
      )
    }
  },
  (error) => {
    if (loadingInstance) loadingInstance.close()
    const { response, message } = error

    const config = error.config

    if (error.response && error.response.data) {
      const { status, data } = response
      //data.msg
      handleCode(status, data.message || message, config.errorMessageClosed)
      return Promise.reject(error)
    } else {
      let { message } = error
      if (message === 'Network Error') {
        message = '后端接口连接异常'
      }
      if (message.includes('timeout')) {
        message = '后端接口请求超时'
      }
      if (message.includes('Request failed with status code')) {
        const code = message.substr(message.length - 3)
        message = '后端接口' + code + '异常'
      }
      Vue.prototype.$baseMessage(
        message || `后端接口未知异常`,
        'error',
        config.errorMessageClosed
      )
      return Promise.reject(error)
    }
  }
)

export default instance
